// @flow
import React from 'react';
import Modal from 'react-modal';
import Box from 'components/Box';
import Dialog from 'components/Dialog';
import BoxBody from 'components/BoxBody';
import { touch } from 'actions/touchActions';
import EventTracking from 'lib/EventTracking';
import SplitComposerDataContainer from './SplitComposerDataContainer';
import ToastActions from 'actions/ToastActions';
import { withRouter } from 'app/context/Router';
import ConfirmDialog from 'components/ConfirmDialog';
import { TOUCH_KEY as STREAM_SECTION_TOUCH_KEY } from 'chat/components/StreamSectionList';
import getRedirectUrlAfterMessageSendToTarget from 'lib/getRedirectUrlAfterMessageSendToTarget';
import { ComposerContext } from './ComposerContext';
import type { UIEventContext } from './ComposerContext';

type Props = any;

type State = {
  isOpen: boolean,
  significantChange: boolean,
  splitComposerPage: 'share_to' | 'composer',
};

class SplitComposerModal extends React.Component<Props, State> {
  state: State = {
    isOpen: false,
    significantChange: false,
    splitComposerPage: 'share_to',
  };

  handleConfirm = () => this.props.onRequestHide();
  handleCancel = () => this.setState({ isOpen: false });

  generateHandleRequestHide = (uiEventContext: UIEventContext) => {
    return () => {
      EventTracking.trackKey(
        `announcements.${this.state.splitComposerPage}.cancel.click`,
        uiEventContext
      );

      if (this.state.significantChange) {
        this.setState({ isOpen: true });
      } else {
        this.props.onRequestHide();
      }
    };
  };

  handleSignificantChange = () => {
    if (!this.state.significantChange) {
      this.setState({ significantChange: true });
    }
  };

  handlePageChange = (newPage: 'share_to' | 'composer') => {
    this.setState({ splitComposerPage: newPage });
  };

  handleMessageSent = (options: * = {}) => {
    if (options.scheduledTime) {
      ToastActions.showSuccessToast('Announcement scheduled');
    } else {
      ToastActions.showSuccessToast('Message sent');
    }

    this.props.onRequestHide();
    touch(STREAM_SECTION_TOUCH_KEY);

    if (options.targets.length === 1) {
      const url = getRedirectUrlAfterMessageSendToTarget(options.targets[0]);

      if (url) {
        this.props.router.push(url);
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.isOpen} data-test="confirm-close-dialog">
          <ConfirmDialog
            hideCloseButton
            cancelButtonText="Cancel"
            actionButtonText="Discard"
            onCancel={this.handleCancel}
            onConfirm={this.handleConfirm}
            onRequestHide={this.handleCancel}
            title={
              this.props.isEditingScheduledMessage
                ? 'Are you sure you want to discard your changes to this message?'
                : 'Are you sure you want to discard this message?'
            }
          />
        </Modal>
        <ComposerContext.Consumer>
          {composerContext => (
            <Dialog
              size="large"
              className="SplitComposerModal"
              onRequestHide={this.generateHandleRequestHide(composerContext.getUIEventContext())}
              box={false /* a boxed dialog has bigger font size than a box in a dialog */}>
              <Box>
                <BoxBody full>
                  <SplitComposerDataContainer
                    {...this.props}
                    onPageChange={this.handlePageChange}
                    onMessageSent={this.handleMessageSent}
                    onSignificantChangeMade={this.handleSignificantChange}
                  />
                </BoxBody>
              </Box>
            </Dialog>
          )}
        </ComposerContext.Consumer>
      </React.Fragment>
    );
  }
}

export { SplitComposerModal };
export default withRouter(SplitComposerModal);
